export default "__VITE_ASSET__7488ed2f__"